// Reactions act as a shared status vocabulary between agents and are visible to
// the customer, so the set is fixed rather than a free emoji picker.
// Keep this list in sync with ALLOWED_REACTIONS in the messages controller.
export const MESSAGE_REACTIONS = [
  { emoji: '👍', labelKey: 'ACKNOWLEDGED' },
  { emoji: '👀', labelKey: 'LOOKING_INTO_IT' },
  { emoji: '✅', labelKey: 'COMPLETED' },
  { emoji: '❤️', labelKey: 'IMPORTANT' },
];

export const REACTION_EMOJIS = MESSAGE_REACTIONS.map(({ emoji }) => emoji);
